import React from 'react'
import PropTypes from 'prop-types'
import {
  StyledModalHeader,
  SectionGoal,
  SectionTitle,
  SectionsWrapper,
} from './component.styles'
import ModalSummarySection from 'components/ModalSummarySection'
import {
  GOALS_LABEL_TEXT,
  IMPLEMENTATION_APPROACH_LABEL_TEXT,
  PURPOSE_STATEMENT_LABEL_TEXT,
} from './constants'
const Summary = ({ handleStepChange, preferences }) => {
  const {
    LessonCompletionGoalValue,
    LessonCompletionGoalDate,
    ClassCreationGoalValue,
    ClassCreationGoalDate,
    Goal3Text,
    Goal3TextIsCompleted,
    Goal3Date,
    Goal4Text,
    Goal4TextIsCompleted,
    Goal4Date,
    Goal5Text,
    Goal5TextIsCompleted,
    Goal5Date,
    ImplementationType,
    LessonCompletionGoalIsDisabled,
    TeacherLed,
    CounselorLed,
    ProgramStartDate,
    Purpose,
  } = preferences || {}
  const teachersAndCounselorLed = TeacherLed && CounselorLed
  return (
    <SectionsWrapper>
      <StyledModalHeader>Summary</StyledModalHeader>
      <ModalSummarySection
        handleOpenEdit={() => handleStepChange(1)}
        sectionName={IMPLEMENTATION_APPROACH_LABEL_TEXT}
      >
        <SectionTitle>Launching with: </SectionTitle>
        {ImplementationType === 'Pilot'
          ? 'Selected Classes or Grades'
          : 'Schoolwide'}
        <br />
        <SectionTitle>Lesson instructors: </SectionTitle>
        {`${TeacherLed ? 'Classroom Teachers' : ''} ${
          teachersAndCounselorLed ? 'and' : ''
        } ${CounselorLed ? 'School Counselors' : ''}`}
      </ModalSummarySection>
      <ModalSummarySection
        handleOpenEdit={() => handleStepChange(3)}
        sectionName={GOALS_LABEL_TEXT}
      >
        <SectionGoal>
          <SectionTitle>Class Creation: </SectionTitle>
          {ClassCreationGoalValue} Second Step® classes will be created.
          <br />
          <SectionTitle>Target date: </SectionTitle>
          {ClassCreationGoalDate &&
            new Date(ClassCreationGoalDate).toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric',
            })}
        </SectionGoal>
        {!LessonCompletionGoalIsDisabled && (
          <SectionGoal>
            <SectionTitle>Lesson Completion: </SectionTitle>
            {LessonCompletionGoalValue}% of available Second Step® lessons will
            be taught at our school.
            <br />
            <SectionTitle>Program start date: </SectionTitle>
            {new Date(ProgramStartDate).toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric',
            })}
            <br />
            <SectionTitle>Target date: </SectionTitle>
            {new Date(LessonCompletionGoalDate).toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric',
            })}
          </SectionGoal>
        )}
        {Goal3Text && Goal3TextIsCompleted && (
          <SectionGoal>
            <SectionTitle>Custom: </SectionTitle>
            {Goal3Text}
            <br />
            <SectionTitle>Target date: </SectionTitle>
            {Goal3Date &&
              new Date(Goal3Date).toLocaleDateString('en-US', {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
              })}
          </SectionGoal>
        )}
        {Goal4Text && Goal4TextIsCompleted && (
          <SectionGoal>
            <SectionTitle>Custom: </SectionTitle>
            {Goal4Text}
            <br />
            <SectionTitle>Target date: </SectionTitle>
            {Goal4Date &&
              new Date(Goal4Date).toLocaleDateString('en-US', {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
              })}
          </SectionGoal>
        )}
        {Goal5Text && Goal5TextIsCompleted && (
          <SectionGoal>
            <SectionTitle>Custom: </SectionTitle>
            {Goal5Text}
            <br />
            <SectionTitle>Target date: </SectionTitle>
            {Goal5Date &&
              new Date(Goal5Date).toLocaleDateString('en-US', {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
              })}
          </SectionGoal>
        )}
      </ModalSummarySection>
      <ModalSummarySection
        handleOpenEdit={() => handleStepChange(2)}
        sectionName={PURPOSE_STATEMENT_LABEL_TEXT}
      >
        {Purpose}
      </ModalSummarySection>
    </SectionsWrapper>
  )
}

Summary.propTypes = {
  handleStepChange: PropTypes.func,
  preferences: PropTypes.object,
}

export default Summary
